import React, { useState } from 'react';
import { Calendar, Menu } from 'lucide-react';

const navLinks = [
  { href: '#anasayfa', label: 'Ana Sayfa' },
  { href: '#hakkimizda', label: 'Hakkımızda' },
  { href: '#hizmetler', label: 'Hizmetler' },
  { href: '#iletisim', label: 'İletişim' },
];

const Navigation = ({ isScrolled }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      {/* Skip Link for Keyboard Navigation */}
      <a href="#main-content" className="skip-link">
        Ana içeriğe geç
      </a>
      
      <header 
        className={`site-header fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'scrolled' : ''}`}
        role="banner"
      >
        <div className="header-inner">
          <div className="logo-area">
            <a href="#anasayfa" className="logo-link" aria-label="Çevik Otomasyon Ana Sayfa">
              <img
                src="/cevik_otomasyon.svg"
                alt="Çevik Otomasyon Logo"
                className="header-logo"
                width="auto"
                height="94"
                loading="eager"
                decoding="sync"
                fetchpriority="high"
              />
            </a>
          </div>
          <nav 
            className={`main-navigation ${mobileOpen ? 'open' : ''}`}
            aria-label="Ana navigasyon"
          >
            <ul className="nav-menu">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} aria-label={link.label}>{link.label}</a>
                </li>
              ))}
              <li>
                <a
                  className="cta-button"
                  href="https://calendly.com/otomasyoncevik/cevik-otomasyon-15-dakikalik-demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="15 dakikalık demo görüşmesi planla (yeni sekmede açılır)"
                >
                  <Calendar className="mr-2 h-4 w-4" aria-hidden="true" />
                  15 Dakikalık Demo
                </a>
              </li>
            </ul>
          </nav>
          <button 
            className="mobile-hamburger" 
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label={mobileOpen ? "Menüyü kapat" : "Menüyü aç"}
            aria-expanded={mobileOpen}
            aria-controls="main-navigation"
          >
            <Menu aria-hidden="true" />
          </button>
        </div>
      </header>
    </>
  );
};

export default Navigation;